import { useContext, useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import {
  Box
  , Container
  , Grid, Typography
} from '@mui/material/'
import Copyright from '../components/Copyright'
import UserForm from '../components/forms/UserForm'
import { ThemeContext } from '../App'

const flag = `url('assets/${process.env.REACT_APP_FLAG}')`

export default function Signup ({ isMobile }) {
  const { mode, toggleTheme } = useContext(ThemeContext)
  const navigate = useNavigate()
  const location = useLocation()
  const token = location.state?.token || null
  
  const logoUrl = mode === 'dark' ? '../assets/adams_logo_white.png' : '../assets/adams_logo_black.png'

  useEffect(() => {
    if (token) return navigate('/home', { state: { token } })
  }, [token, navigate])

  return (
    <Container component="main" maxWidth={isMobile ? 'xs' : 'sm'}>
      <Box
        mt={8}
        display='flex'
        flexDirection='column'
        alignItems='center'
      >
       
        <Box width='50%'>
          <img src={logoUrl} alt='ADaMS logo' width='100%' />
        </Box>
        <UserForm isMobile={isMobile} token={token} />
        <Typography variant='body2'>
          <Trans>Already signed up? Please&nbsp;
            <Link to="/">login</Link>
          </Trans>
        </Typography>
      </Box>
      <Grid container sx={{ display: 'flex', marginTop: 4 }} spacing={2}>
          <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="../assets/logo_fred_nero.png" height={'auto'} width={200}></img>
          </Grid>
          <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="../assets/Flag_of_Guinea.png" height={'auto'} width={120}></img>
          </Grid>
          <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="../assets/Coat_of_Arms_of_Guinea.png" height={'auto'} width={100}></img>
          </Grid>
        </Grid>
      <Box mt={4} display='flex' justifyContent='center'>
        <Copyright />
      </Box>
    </Container>
  )
}
